import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiPlus, FiEdit2, FiTrash2, FiCalendar, FiUsers, FiMapPin, FiInbox, FiAlertTriangle, FiCopy, FiInfo, FiX, FiCamera, FiDownload, FiChevronDown, FiChevronUp, FiFileText, FiArrowDown, FiSettings, FiMessageSquare, FiShare2, FiAward, FiCheck, FiEye, FiEyeOff } from 'react-icons/fi';

// Firebase importok - BŐVÍTVE: doc, deleteDoc, updateDoc, runTransaction
import { db, auth, storage } from '../../firebase';
import { collection, query, where, onSnapshot, doc, deleteDoc, getDocs, writeBatch, runTransaction, updateDoc, getDoc, serverTimestamp, addDoc, setDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { saveCompetitionOffline, getAllCompetitionsOffline, getOfflineParticipantsCount, getCompetitionOffline, cacheCompetitions, deleteCompetitionOffline } from '../../utils/offlineDB';
import downloadHelpImg from '../../downloadhelp.png';
import Tournaments from './Tournaments';

const ClubDashboard = () => {
  const navigate = useNavigate();
  const [competitions, setCompetitions] = useState([]);
  const [closedCompetitions, setClosedCompetitions] = useState([]);
  const [clubData, setClubData] = useState(null); // ÚJ: Klub adatok (kreditekhez)
  const [followersList, setFollowersList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isUploadingLogo, setIsUploadingLogo] = useState(false); // ÚJ: Feltöltés állapot
  const fileInputRef = React.useRef(null); // ÚJ: File input ref
  const [user, setUser] = useState(null);
  const [activeTab, setActiveTab] = useState('active');
  const [expandedMenu, setExpandedMenu] = useState('competitions');
  const [pendingInvitations, setPendingInvitations] = useState([]); // VISSZARAKVA a menü piros pöttye miatt

  // --- FELTURBÓZOTT MEGOSZTÁSI MODAL ÁLLAPOTOK ---
  const [showShareModal, setShowShareModal] = useState(false);
  const [compToShare, setCompToShare] = useState(null);
  const [shareCustomCaption, setShareCustomCaption] = useState('');
  const [sharePosterFile, setSharePosterFile] = useState(null);
  const [sharePosterPreview, setSharePosterPreview] = useState(null);
  const [isUploadingPoster, setIsUploadingPoster] = useState(false);
  const [isPublishingFeedPost, setIsPublishingFeedPost] = useState(false);
  const [copySuccess, setCopySuccess] = useState(false);

  const [expandedRatingCompId, setExpandedRatingCompId] = useState(null);
  const [competitionAverages, setCompetitionAverages] = useState({});

  const handleToggleRatings = async (comp) => {
    if (expandedRatingCompId === comp.id) {
      setExpandedRatingCompId(null);
      return;
    }
    setExpandedRatingCompId(comp.id);
    if (!competitionAverages[comp.id]) {
      try {
        const ratingsSnap = await getDocs(collection(db, "events_closed", comp.id, "ratings"));
        let pSum = 0, oSum = 0, orgSum = 0, cSum = 0, catSum = 0;
        let count = 0;
        ratingsSnap.forEach(d => {
          const data = d.data();
          if (d.id === 'organizer_review' || data.organizer_review || data.type === 'organizer_review') return;

          pSum += Number(data.parking) || 0;
          oSum += Number(data.office) || 0;
          orgSum += Number(data.organization) || 0;
          cSum += Number(data.course) || 0;
          catSum += Number(data.catering) || 0;
          count++;
        });

        const averages = count > 0 ? {
          parking: (pSum / count).toFixed(1),
          office: (oSum / count).toFixed(1),
          organization: (orgSum / count).toFixed(1),
          course: (cSum / count).toFixed(1),
          catering: (catSum / count).toFixed(1),
          count: count
        } : { parking: '-', office: '-', organization: '-', course: '-', catering: '-', count: 0 };

        setCompetitionAverages(prev => ({ ...prev, [comp.id]: averages }));
      } catch (e) {
        console.error("Hiba az értékelések lekérésekor:", e);
      }
    }
  };

  const handleOpenShareModal = (comp) => {
    setCompToShare(comp);
    setShareCustomCaption(`Szeretettel várunk mindenkit a(z) ${comp.competitionName || comp.title} versenyünkön! 🏹`);
    setSharePosterFile(null);
    setSharePosterPreview(comp.coverImageUrl || comp.imageUrl || null);
    setCopySuccess(false);
    setShowShareModal(true);
  };

  const handleSelectPosterFile = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!file.type.startsWith('image/')) {
      alert("Kérjük, csak képfájlt válassz ki!");
      return;
    }
    setSharePosterFile(file);
    setSharePosterPreview(URL.createObjectURL(file));
  };

  const handlePublishToCommunityFeed = async () => {
    if (!compToShare || !user) return;
    setIsPublishingFeedPost(true);
    try {
      let finalCoverUrl = compToShare.coverImageUrl || compToShare.imageUrl || null;

      // 1. Ha van kiválasztott új plakát képfájl, feltöltjük Firebase Storage-ba
      if (sharePosterFile) {
        setIsUploadingPoster(true);
        const fileExt = sharePosterFile.name.split('.').pop() || 'jpg';
        const posterRef = ref(storage, `shared_images/${user.uid}/cover_${compToShare.id}.${fileExt}`);
        await uploadBytes(posterRef, sharePosterFile);
        finalCoverUrl = await getDownloadURL(posterRef);
        setIsUploadingPoster(false);

        // Elmentsük a verseny dokumentumba is a borítóképet
        const collectionName = activeTab === 'active' ? 'events' : 'events_closed';
        await updateDoc(doc(db, collectionName, compToShare.id), {
          coverImageUrl: finalCoverUrl
        });

        // Helyi állapot frissítése
        setCompetitions(prev => prev.map(c => c.id === compToShare.id ? { ...c, coverImageUrl: finalCoverUrl } : c));
      }

      // 2. Poszt rögzítése az egyesület saját Clubs/{clubId}/posts algyűjteményébe
      const feedRef = collection(db, "Clubs", user.uid, "posts");
      const clubName = clubData?.clubName || user.displayName || "Egyesület";
      const clubLogo = clubData?.logoUrl || null;

      const newPostRef = await addDoc(feedRef, {
        authorName: clubName,
        authorUid: user.uid,
        authorImage: clubLogo,
        title: `🏹 VERSENY: ${compToShare.competitionName || compToShare.title}`,
        content: `${shareCustomCaption}\n\n📅 Dátum: ${compToShare.competitionDate || compToShare.startDate || 'Nincs megadva'}\n📍 Helyszín: ${compToShare.location || 'Nincs megadva'}`,
        imageUrl: finalCoverUrl || clubLogo,
        eventId: compToShare.id,
        createdAt: serverTimestamp(),
        isClubPost: true,
        isSystemPost: false
      });

      // Rárögzítjük a megosztási jelvényt a verseny dokumentumra is
      const collectionName = activeTab === 'active' ? 'events' : 'events_closed';
      await updateDoc(doc(db, collectionName, compToShare.id), {
        isFeedShared: true,
        feedPostId: newPostRef.id
      });

      // Helyi állapot frissítése
      setCompetitions(prev => prev.map(c => c.id === compToShare.id ? { ...c, isFeedShared: true, feedPostId: newPostRef.id } : c));

      alert("Sikeresen megosztva az ArcheryNexus közösségi hírfolyamában! 🏹📣");
      setShowShareModal(false);
      setCompToShare(null);
    } catch (err) {
      console.error("Hiba a hírfolyam posztolásakor:", err);
      alert("Hiba történt a megosztás során!");
    } finally {
      setIsPublishingFeedPost(false);
      setIsUploadingPoster(false);
    }
  };

  const handleRevokeShareSubmit = async () => {
    if (!compToRevokeShare || !user) return;
    setIsRevokingShare(true);
    try {
      const clubPostsRef = collection(db, "Clubs", user.uid, "posts");
      const q = query(clubPostsRef, where("eventId", "==", compToRevokeShare.id));
      const snap = await getDocs(q);
      const batch = writeBatch(db);
      snap.forEach(docSnap => {
        batch.delete(docSnap.ref);
      });

      try {
        const adminQ = query(collection(db, "AdminFeed"), where("eventId", "==", compToRevokeShare.id));
        const adminSnap = await getDocs(adminQ);
        adminSnap.forEach(adminDoc => {
          batch.delete(adminDoc.ref);
        });
      } catch (e) {
        console.error("AdminFeed törlési hiba:", e);
      }

      const collectionName = activeTab === 'active' ? 'events' : 'events_closed';
      const eventRef = doc(db, collectionName, compToRevokeShare.id);
      batch.update(eventRef, {
        isFeedShared: false,
        feedPostId: null
      });

      await batch.commit();

      setCompetitions(prev => prev.map(c => c.id === compToRevokeShare.id ? { ...c, isFeedShared: false, feedPostId: null } : c));

      alert("Megosztás sikeresen visszavonva az App Hírfolyamból! 🏹");
      setShowRevokeShareModal(false);
      setCompToRevokeShare(null);
    } catch (err) {
      console.error("Hiba a megosztás visszavonásakor:", err);
      alert("Hiba történt a megosztás visszavonása során!");
    } finally {
      setIsRevokingShare(false);
    }
  };

  const handleCopyLink = () => {
    if (!compToShare) return;
    const url = `https://archerynexus.com/verseny/${compToShare.id}`;
    navigator.clipboard.writeText(url);
    setCopySuccess(true);
    setTimeout(() => setCopySuccess(false), 2000);
  };

  // --- ÚJ: ÉRTESÍTÉSEK (MEGHÍVÓK) FIGYELÉSE A MENÜ PÖTTYHÖZ ---
  useEffect(() => {
    if (!user) return;
    const q = query(
      collection(db, "notifications"),
      where("toUserId", "==", user.uid),
      where("status", "==", "unread")
    );
    const unsubscribeNotifications = onSnapshot(q, (snapshot) => {
      const invites = [];
      snapshot.forEach((doc) => invites.push({ id: doc.id, ...doc.data() }));
      setPendingInvitations(invites);
    });
    return () => unsubscribeNotifications();
  }, [user]);

  // Követők betöltése és egyszeri migráció / név frissítés
  useEffect(() => {
    if (!user) return;

    const followersRef = collection(db, "Clubs", user.uid, "followers");
    const unsubscribe = onSnapshot(followersRef, async (snapshot) => {
      const followers = [];
      const batch = writeBatch(db);
      let needsBatchCommit = false;

      for (const followerDoc of snapshot.docs) {
        const data = followerDoc.data();
        let fullName = data.fullName;

        // Ha a név "Ismeretlen felhasználó", megpróbáljuk lekérni a friss user adatot
        if (!fullName || fullName === "Ismeretlen felhasználó") {
          try {
            const userSnap = await getDoc(doc(db, "users", followerDoc.id));
            if (userSnap.exists()) {
              const uData = userSnap.data();
              fullName = uData.fullName || uData.displayName || `${uData.lastName || ''} ${uData.firstName || ''}`.trim() || uData.name || uData.email || "Ismeretlen felhasználó";
              if (fullName !== "Ismeretlen felhasználó") {
                batch.update(doc(db, "Clubs", user.uid, "followers", followerDoc.id), { fullName });
                needsBatchCommit = true;
              }
            }
          } catch (e) {
            console.error("Hiba a követő nevének frissítésekor:", e);
          }
        }

        followers.push({ id: followerDoc.id, ...data, fullName: fullName || data.fullName });
      }

      if (needsBatchCommit) {
        await batch.commit();
      }

      setFollowersList(followers);

      // --- EGYSZERI MIGRÁCIÓ ELLENŐRZÉS ---
      if (!clubData?.migratedFollowers && clubData !== null) {
        try {
          const usersSnap = await getDocs(collection(db, "users"));
          let migratedCount = 0;
          const migrationBatch = writeBatch(db);

          for (const userDoc of usersSnap.docs) {
            const userId = userDoc.id;
            const userData = userDoc.data();
            const followedRef = doc(db, "users", userId, "followedClubs", user.uid);
            const followedSnap = await getDoc(followedRef);

            if (followedSnap.exists()) {
              const fullName = userData.fullName || userData.displayName || `${userData.lastName || ''} ${userData.firstName || ''}`.trim() || userData.name || userData.email || "Ismeretlen felhasználó";
              const followerDocRef = doc(db, "Clubs", user.uid, "followers", userId);
              migrationBatch.set(followerDocRef, {
                uid: userId,
                fullName: fullName,
                club: userData.clubName || userData.club || "Egyéni induló",
                profileImageUrl: userData.profileImageUrl || userData.photoUrl || "",
                migratedAt: serverTimestamp()
              }, { merge: true });
              migratedCount++;
            }
          }

          const clubRef = doc(db, "Clubs", user.uid);
          migrationBatch.update(clubRef, {
            migratedFollowers: true,
            followersCount: Math.max(followers.length, migratedCount)
          });

          await migrationBatch.commit();
        } catch (e) {
          console.error("Hiba a követők migrációjakor:", e);
        }
      }
    });

    return () => unsubscribe();
  }, [user, clubData?.migratedFollowers]);

  // --- ÚJ: EGYESÜLETI PROFIL SZERKESZTŐ ÁLLAPOTOK ---
  const [profileForm, setProfileForm] = useState({
    clubName: '',
    contactPerson: '',
    email: '',
    phone: '',
    country: '',
    location: '',
    address: ''
  });
  const [isSavingProfile, setIsSavingProfile] = useState(false);

  // Profil adatok betöltése a formba, ha megérkezik a clubData
  useEffect(() => {
    if (clubData) {
      setProfileForm({
        clubName: clubData.clubName || '',
        contactPerson: clubData.contactPerson || '',
        email: clubData.email || '',
        phone: clubData.phone || '',
        country: clubData.country || 'Magyarország',
        location: clubData.location || '',
        address: clubData.address || ''
      });
    }
  }, [clubData]);

  const handleSaveClubProfile = async () => {
    if (!user) return;
    setIsSavingProfile(true);
    try {
      const clubRef = doc(db, "Clubs", user.uid);
      await updateDoc(clubRef, {
        ...profileForm,
        updatedAt: new Date().toISOString()
      });
      alert("Egyesületi profil sikeresen frissítve! 🏹✅");
      setActiveTab('active'); // Visszatérés az aktív versenyekhez
    } catch (error) {
      console.error("Hiba a profil mentésekor:", error);
      alert("Nem sikerült a mentés.");
    } finally {
      setIsSavingProfile(false);
    }
  };

  // --- MODAL ÁLLAPOTOK ---
  const [showModal, setShowModal] = useState(false);
  const [showRevokeShareModal, setShowRevokeShareModal] = useState(false);
  const [compToRevokeShare, setCompToRevokeShare] = useState(null);
  const [isRevokingShare, setIsRevokingShare] = useState(false);

  const openRevokeShareModal = (comp) => {
    setCompToRevokeShare(comp);
    setShowRevokeShareModal(true);
  };
  const [showOpenRegistrationModal, setShowOpenRegistrationModal] = useState(false);
  const [showInstallInfoModal, setShowInstallInfoModal] = useState(false);
  const [showPublishConfirmModal, setShowPublishConfirmModal] = useState(false); // ÚJ: Publikálás megerősítő modal
  const [compToPublish, setCompToPublish] = useState(null); // ÚJ: Kiválasztott verseny a publikáláshoz
  const [isPublishing, setIsPublishing] = useState(false); // ÚJ: Publikálás folyamatban
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isStandalone, setIsStandalone] = useState(false); // ÚJ: Alkalmazás mód figyelése
  const [compToOpen, setCompToOpen] = useState(null);
  const [compToDelete, setCompToDelete] = useState(null);
  const [offlineStats, setOfflineStats] = useState({}); // ÚJ: { compId: count } a gombokhoz
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  const [expandedYears, setExpandedYears] = useState({}); // ÚJ: Évenkénti lenyíló sávokhoz

  // --- ÚJ: ARCHERYNEXUS ÉRTÉKELŐ MODAL ÁLLAPOTOK ---
  const [showRatingModal, setShowRatingModal] = useState(false);
  const [compBeingRated, setCompBeingRated] = useState(null);
  const [ratingForm, setRatingForm] = useState({
    usability: 3,
    clarity: 3,
    reliability: 3,
    participantsManagement: 3,
    resultsAggregation: 3,
    wouldRecommend: true,
    comment: ''
  });
  const [isSubmittingRating, setIsSubmittingRating] = useState(false);

  const handleSaveRating = async () => {
    if (!compBeingRated) return;
    setIsSubmittingRating(true);
    try {
      const ratingRef = doc(db, "events_closed", compBeingRated.id, "ratings", "organizer_review");
      await setDoc(ratingRef, {
        ...ratingForm,
        submittedAt: serverTimestamp(),
        organizerId: user?.uid || '',
        competitionId: compBeingRated.id,
        competitionName: compBeingRated.competitionName || compBeingRated.title || ''
      });
      alert("Köszönjük az értékelést! 🏹⭐");
    } catch (err) {
      console.error("Hiba az értékelés mentésekor:", err);
    } finally {
      setIsSubmittingRating(false);
      setShowRatingModal(false);
      setCompBeingRated(null);
    }
  };

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 1024);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // 1. Auth állapot figyelése ÉS Kezdeti offline betöltés
  useEffect(() => {
    const fetchInitialOfflineData = async () => {
      try {
        // 1. Helyi profil betöltése (gyorsabb mint az IndexedDB)
        const savedProfile = localStorage.getItem(`club_profile_${auth.currentUser?.uid}`);
        if (savedProfile) {
          setClubData(JSON.parse(savedProfile));
        }

        // 2. Versenyek betöltése IndexedDB-ből
        const offComps = await getAllCompetitionsOffline();
        if (offComps && offComps.length > 0) {
          const active = offComps.filter(c => c.status !== 'Ready to Upload' && c.status !== 'Lezárt');
          const closed = offComps.filter(c => c.status === 'Ready to Upload' || c.status === 'Lezárt');

          setCompetitions(active);
          setClosedCompetitions(closed);
          setLoading(false); // Ha van offline adat, már nem mutatunk üres töltést
        }
      } catch (e) {
        console.error("Hiba az offline adatok betöltésekor:", e);
      }
    };

    fetchInitialOfflineData();

    const unsubscribeAuth = auth.onAuthStateChanged((currentUser) => {
      setUser(currentUser);
      if (!currentUser) setLoading(false);
    });
    return () => unsubscribeAuth();
  }, []);

  // 1b. PWA Telepítési esemény figyelése
  useEffect(() => {
    // ... meglévő kód ...
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);

    // Detektáljuk, ha már standalone módban futunk
    const isStandaloneMode = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
    setIsStandalone(!!isStandaloneMode);

    // ÚJ: Offline adatok állapotának lekérése az induláskor
    const fetchOfflineStats = async () => {
      try {
        const offComps = await getAllCompetitionsOffline();
        const stats = {};
        for (const c of offComps) {
          const count = await getOfflineParticipantsCount(c.id);
          stats[c.id] = count;
        }
        setOfflineStats(stats);
      } catch (e) {
        console.error("Hiba az offline statisztika lekérésekor:", e);
      }
    };
    fetchOfflineStats();

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) {
      alert("A böngésződ még nem készítette elő a telepítést. \n\nKérlek, keresd a (+) vagy 'Telepítés' ikont a címsorban, vagy várj pár másodpercet!");
      return;
    }
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') {
      setDeferredPrompt(null);
    }
    setShowInstallInfoModal(false);
  };

  // 2. Adatok lekérése - INDEX-MENTESÍTVE az azonnali betöltéshez
  useEffect(() => {
    if (!user) return;

    console.log("Lekérés indítása: events, user:", user.uid);
    const q = query(
      collection(db, "events"),
      where("organizerId", "==", user.uid)
    );

    const unsubscribeSnapshot = onSnapshot(q, async (querySnapshot) => {
      // VÉDELEM: Ha üres a szerver válasza ÉS offline vagyunk, ne töröljük a listát
      if (querySnapshot.empty && !navigator.onLine) return;

      const serverComps = [];
      querySnapshot.forEach((doc) => {
        serverComps.push({ id: doc.id, ...doc.data() });
      });

      // --- AUTOMATA MENTÉS INDEXEDDB-BE ---
      if (serverComps.length > 0) {
        cacheCompetitions(serverComps);
      }

      // --- ÚJ: Hibrid Összefésülés (Helyi prioritás a lezáráshoz és offline jelvényhez) ---
      try {
        const offComps = await getAllCompetitionsOffline();
        const offlineMap = new Map(offComps.map(c => [c.id, c]));
        const locallyClosedIds = new Set(offComps.filter(c => c.status === 'Ready to Upload').map(c => c.id));

        // Csak azokat tartjuk meg az aktívak között, amik a laptopon nincsenek lezárva
        const filteredComps = serverComps.filter(c => !locallyClosedIds.has(c.id)).map(c => {
          const off = offlineMap.get(c.id);
          return off?.isOfflineDownloaded ? { ...c, isOfflineDownloaded: true } : c;
        });

        // MANUÁLIS RENDEZÉS
        filteredComps.sort((a, b) => {
          const dateA = a.createdAt?.seconds || 0;
          const dateB = b.createdAt?.seconds || 0;
          return dateB - dateA;
        });

        setCompetitions(filteredComps);
      } catch (e) {
        console.error("Hiba az offline összefésüléskor (aktív):", e);
        setCompetitions(serverComps);
      }
      setLoading(false);
    }, async (error) => {
      console.error("Hiba az events lekérésekor:", error);
      // OFFLINE TARTALÉK: Ha hiba van (pl. nincs net), megpróbáljuk az offline tárolóból
      if (!navigator.onLine) {
        try {
          const offComps = await getAllCompetitionsOffline();
          setCompetitions(offComps);
        } catch (e) {
          console.error("Hiba az offline versenyek lekérésekor:", e);
        }
      }
      setLoading(false);
    });

    return () => unsubscribeSnapshot();
  }, [user]);

  // 3. Lezárt adatok lekérése az events_closed gyűjteményből
  useEffect(() => {
    if (!user) return;

    console.log("Lekérés indítása: events_closed, user:", user.uid);
    const q = query(
      collection(db, "events_closed"),
      where("organizerId", "==", user.uid)
    );

    const unsubscribeClosed = onSnapshot(q, async (querySnapshot) => {
      // VÉDELEM: Ha üres a szerver válasza ÉS offline vagyunk, ne töröljük a listát
      if (querySnapshot.empty && !navigator.onLine) return;

      const serverComps = [];
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        // CSAK AKKOR adjuk a listához, ha a szervező még nem rejtette el magától
        if (!data.hiddenForOrganizer) {
          serverComps.push({ id: doc.id, ...data });
        }
      });

      // --- AUTOMATA MENTÉS INDEXEDDB-BE ---
      if (serverComps.length > 0) {
        cacheCompetitions(serverComps);
      }

      // --- ÚJ: Hibrid Összefésülés (Helyi "Ready to Upload" versenyek hozzáadása) ---
      try {
        const offComps = await getAllCompetitionsOffline();
        const readyToUpload = offComps.filter(c => c.status === 'Ready to Upload');

        // Összefésüljük a szerveres lezártakat a feltöltésre várókkal
        let allClosed = [...serverComps, ...readyToUpload];

        // Duplikáció szűrés (ha a szerveren is ott lenne véletlenül)
        const seen = new Set();
        allClosed = allClosed.filter(c => {
          if (seen.has(c.id)) return false;
          seen.add(c.id);
          return true;
        });

        allClosed.sort((a, b) => {
          const dateA = a.closedAt ? new Date(a.closedAt).getTime() : 0;
          const dateB = b.closedAt ? new Date(b.closedAt).getTime() : 0;
          return dateB - dateA;
        });

        setClosedCompetitions(allClosed);
      } catch (e) {
        console.error("Hiba az offline összefésüléskor (lezárt):", e);
        setClosedCompetitions(serverComps);
      }
    }, (error) => {
      console.error("Hiba az events_closed lekérésekor:", error);
    });

    return () => unsubscribeClosed();
  }, [user]);

  // 4. Klub adatok lekérése
  useEffect(() => {
    if (!user) return;

    const clubRef = doc(db, "Clubs", user.uid);
    const unsubscribeClub = onSnapshot(clubRef, (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        setClubData(data);
        localStorage.setItem(`club_profile_${user.uid}`, JSON.stringify(data));
      } else {
        setClubData({});
      }
    });

    return () => unsubscribeClub();
  }, [user]);

  // --- ÚJ: ÉRTESÍTÉSEK (MEGHÍVÓK) FIGYELÉSE ---
  useEffect(() => {
    if (!user) return;

    const q = query(
      collection(db, "notifications"),
      where("toUserId", "==", user.uid),
      where("status", "==", "unread")
    );

    const unsubscribeNotifications = onSnapshot(q, (snapshot) => {
      const invites = [];
      snapshot.forEach((doc) => {
        invites.push({ id: doc.id, ...doc.data() });
      });
      setPendingInvitations(invites);
    });

    return () => unsubscribeNotifications();
  }, [user]);

  // --- LOGÓ FELTÖLTÉS LOGIKA ---
  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file || !user) return;

    // Fájltípus ellenőrzés
    if (!file.type.startsWith('image/')) {
      alert("Kérlek, csak képfájlt válassz ki!");
      return;
    }

    setIsUploadingLogo(true);
    try {
      // 1. Feltöltés Firebase Storage-ba
      const logoRef = ref(storage, `club_logos/${user.uid}`);
      await uploadBytes(logoRef, file);

      // 2. Letöltési URL lekérése
      const downloadUrl = await getDownloadURL(logoRef);

      // 3. Adatbázis frissítése
      const clubRef = doc(db, "Clubs", user.uid);
      await updateDoc(clubRef, { logoUrl: downloadUrl });

      console.log("Logó sikeresen feltöltve:", downloadUrl);
    } catch (error) {
      console.error("Hiba a logó feltöltésekor:", error);
      alert("Nem sikerült a logó feltöltése!");
    } finally {
      setIsUploadingLogo(false);
    }
  };

  // --- TÖRLÉS LOGIKA ---
  const openDeleteModal = (comp) => {
    setCompToDelete(comp);
    setShowModal(true);
  };

  const handleFinalDelete = async () => {
    if (!compToDelete) return;

    const collectionName = activeTab === 'active' ? "events" : "events_closed";

    try {
      // HA AKTÍV VERSENYT TÖRÖL -> VÉGLEGES TÖRLÉS AZ ADATBÁZISBÓL ÉS STORAGE-BÓL
      if (activeTab === 'active') {
        // 0. Képek törlése Firebase Storage-ból (borítókép/plakát + pályatérkép)
        const coverUrl = compToDelete.coverImageUrl || compToDelete.imageUrl;
        if (coverUrl && coverUrl.includes('firebasestorage.googleapis.com')) {
          try {
            const coverRef = ref(storage, coverUrl);
            await deleteObject(coverRef);
          } catch (e) {
            console.error("Borítókép törlési hiba Storage-ból:", e);
          }
        }

        const mapUrl = compToDelete.courseMapImageUrl;
        if (mapUrl && mapUrl.includes('firebasestorage.googleapis.com')) {
          try {
            const mapRef = ref(storage, mapUrl);
            await deleteObject(mapRef);
          } catch (e) {
            console.error("Pályatérkép törlési hiba Storage-ból:", e);
          }
        }

        const batch = writeBatch(db);

        // 1. Nevezők (participants) lekérése és törlése a batch-ben
        const participantsRef = collection(db, collectionName, compToDelete.id, "participants");
        const participantsSnap = await getDocs(participantsRef);
        participantsSnap.forEach((participantDoc) => {
          batch.delete(participantDoc.ref);
        });

        // 2. A verseny fő dokumentumának hozzáadása a törlési listához
        batch.delete(doc(db, collectionName, compToDelete.id));

        // 3. Végrehajtjuk a teljes törlést egyszerre
        await batch.commit();

        // 4. Helyi IndexedDB memóriából és localStorage-ból is azonnal kitöröljük
        await deleteCompetitionOffline(compToDelete.id);
        try {
          localStorage.removeItem(`offline_downloaded_${compToDelete.id}`);
        } catch (e) {}

        // Frissítjük a helyi állapotot
        setCompetitions(prev => prev.filter(c => c.id !== compToDelete.id));
      }
      // HA LEZÁRT VERSENYT "TÖRÖL" -> CSAK ELREJTI A DASHBOARDRÓL (Eredmények maradnak a publikum felé!)
      else {
        const closedRef = doc(db, collectionName, compToDelete.id);
        await updateDoc(closedRef, { hiddenForOrganizer: true });

        // Frissítjük a helyi állapotot
        setClosedCompetitions(prev => prev.filter(c => c.id !== compToDelete.id));
      }
      
      setShowModal(false);
      setCompToDelete(null);
    } catch (error) {
      console.error("Hiba a törlés során:", error);
      alert("A művelet sikertelen!");
    }
  };

  const handleToggleHideCompetition = async (comp) => {
    try {
      const newHiddenState = !comp.isHidden;
      const rawName = comp.competitionName || comp.title || "";
      const cleanName = rawName.replace(/^🔴\s*\[REJTETT\]\s*/i, "").trim();
      const finalName = newHiddenState ? `🔴 [REJTETT] ${cleanName}` : cleanName;

      const eventRef = doc(db, "events", comp.id);
      await updateDoc(eventRef, {
        isHidden: newHiddenState,
        competitionName: finalName
      });

      setCompetitions(prev => prev.map(c =>
        c.id === comp.id ? { ...c, isHidden: newHiddenState, competitionName: finalName } : c
      ));
    } catch (err) {
      console.error("Hiba a láthatóság módosításakor:", err);
      alert("Hiba történt a láthatóság módosítása során.");
    }
  };

  const handleOpenRegistration = async () => {
    if (!compToOpen) return;
    try {
      const docRef = doc(db, "events", compToOpen.id);
      await updateDoc(docRef, { creationType: 'full_event' });
      setShowOpenRegistrationModal(false);
      setCompToOpen(null);
    } catch (error) {
      console.error("Hiba a nevezés megnyitásakor:", error);
      alert("Nem sikerült megnyitni a nevezést!");
    }
  };

  const downloadCompetitionOffline = async (comp) => {
    try {
      // 1. Lekérjük az összes nevezőt ehhez a versenyhez
      const participantsRef = collection(db, "events", comp.id, "participants");
      const participantsSnap = await getDocs(participantsRef);
      const participantsData = participantsSnap.docs.map(doc => ({ ...doc.data(), id: doc.id }));

      // 2. Mentés IndexedDB-be és localStorage-ba az azonnali 0ms perzisztenciáért
      await saveCompetitionOffline(comp, participantsData);
      try {
        localStorage.setItem(`offline_downloaded_${comp.id}`, 'true');
      } catch (e) {}

      // --- ÚJ: AUTOMATIKUS SZÁMLÁLÓ JAVÍTÁS (Öntisztító funkció) ---
      const actualCount = participantsData.length;
      if (Number(comp.participantsCount) !== actualCount) {
        const eventRef = doc(db, "events", comp.id);
        await updateDoc(eventRef, { participantsCount: actualCount });
      }

      // 3. Frissítjük a helyi állapotot és a versenylistát, hogy a számláló és a gomb színe azonnal szinkronba kerüljön
      setCompetitions(prev => prev.map(c => c.id === comp.id ? { ...c, participantsCount: actualCount } : c));
      setOfflineStats(prev => ({
        ...prev,
        [comp.id]: actualCount
      }));

      alert(`Sikeresen letöltve: ${comp.competitionName}\nMostantól használhatod offline módban is! 🏹✅`);
    } catch (error) {
      console.error("Hiba a letöltéskor:", error);
      alert("Hiba történt az adatok letöltése közben.");
    }
  };

  const handleFinalPublish = async () => {
    if (!compToPublish) return;
    setIsPublishing(true);
    try {
      // 1. ADATOLVASÁS: A laptopon tárolt legfrissebb adatokat használjuk!
      const offlineData = await getCompetitionOffline(compToPublish.id);
      const finalCompetition = offlineData.competition || compToPublish;
      const finalParticipants = offlineData.participants || [];

      if (finalParticipants.length === 0) {
        // Ha nincs helyi adat, megpróbáljuk a szerverről (hátha csak online lezárás volt)
        const participantsRef = collection(db, "events", compToPublish.id, "participants");
        const participantsSnap = await getDocs(participantsRef);
        participantsSnap.docs.forEach(doc => finalParticipants.push({ id: doc.id, ...doc.data() }));
      }

      const batch = writeBatch(db);

      // 2. FELTÖLTÉS ÉS LEZÁRÁS EGYBEN
      const closedEventRef = doc(db, "events_closed", compToPublish.id);
      batch.set(closedEventRef, {
        ...finalCompetition,
        status: 'Lezárt',
        published: true,
        closedAt: new Date().toISOString(),
        finalResultCount: finalParticipants.length
      });

      // 3. Résztvevők másolása (A laptopon lévő pontokkal!)
      finalParticipants.forEach(p => {
        const pRef = doc(db, "events_closed", compToPublish.id, "participants", p.id);
        batch.set(pRef, p);

        // Eredeti törlése a szerverről
        const oldPRef = doc(db, "events", compToPublish.id, "participants", p.id);
        batch.delete(oldPRef);
      });

      // 4. Eredeti verseny törlése a szerverről
      batch.delete(doc(db, "events", compToPublish.id));

      await batch.commit();

      setShowPublishConfirmModal(false);
      const publishedComp = compToPublish;
      setCompToPublish(null);

      // Megnyitjuk az értékelő modalt CSAK EZUTÁN!
      setCompBeingRated(publishedComp);
      setShowRatingModal(true);
    } catch (error) {
      console.error("Hiba a publikáláskor:", error);
      alert("Hiba történt a feltöltés során. Ellenőrizd az internetkapcsolatot!");
    } finally {
      setIsPublishing(false);
    }
  };

  const handleCopyCompetition = (comp) => {
    // Adatok másolása és tisztítása
    const {
      id,
      participantsCount,
      createdAt,
      closedAt,
      status,
      registrationClosed,
      competitionDate,
      startDate,
      endDate,
      registrationDeadline,
      registrationChangeDeadline,
      courseMapPublished,
      courseMapPublishedAt,
      courseMapImageUrl,
      coverImageUrl,
      imageUrl,
      ...rest
    } = comp;

    const copiedData = {
      ...rest,
      competitionName: `${comp.competitionName || comp.title} (MÁSOLAT)`,
      // Dátumokat ürítjük, hogy a szervezőnek meg kelljen adnia az újat
      competitionDate: '',
      startDate: '',
      endDate: '',
      registrationDeadline: '',
      registrationChangeDeadline: '',
      courseMapPublished: false,
      courseMapImageUrl: '',
      creationType: 'full_event',
      status: 'Aktív'
    };

    navigate('/verseny-letrehozas', { state: { copiedCompetition: copiedData } });
  };

  // Statisztika számítása
  const totalParticipants = competitions.reduce((sum, comp) => sum + (Number(comp.participantsCount) || 0), 0);

  if (loading && !user) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <p style={{ fontSize: '1.2rem', color: '#b30000', fontWeight: 'bold' }}>Betöltés...</p>
      </div>
    );
  }

  // Versenyek szétválogatása
  const activeCompetitions = competitions.filter(c => c.status !== 'Ready to Upload' && c.status !== 'Lezárt');
  const readyToUploadComps = competitions.filter(c => c.status === 'Ready to Upload');
  const pastCompetitions = [...readyToUploadComps, ...closedCompetitions];
  
  // Éppen megjelenítendő lista
  const displayCompetitions = activeTab === 'active' ? activeCompetitions : pastCompetitions;

  // --- ZÁRT BÉTA ELLENŐRZÉS (Kupasorozat és Kísérleti Funkciók) ---
  const isBetaTester = user?.uid === '7Y83A90XgvWBr8WLIKoNcxkkS0R2' ||
                       user?.uid === 'zCyBmOiFqRSLq5KHUf12MDxGqgq2' ||
                       user?.uid === 'hAWdycmLQpSBewFNJTvyLembkVw1';

  // --- ÚJ: MEGHÍVÓ ELFOGADÁSA/ELUTASÍTÁSA ---
  const handleAcceptInvite = async (invite) => {
    try {
      const batch = writeBatch(db);

      // 1. Értesítés törlése (elfogadás után már nem kell)
      batch.delete(doc(db, "notifications", invite.id));

      // 2. Kupa dokumentumban az organizers tömb frissítése (status: pending -> active)
      const tRef = doc(db, "tournaments", invite.tournamentId);
      const tSnap = await getDoc(tRef);
      if (tSnap.exists()) {
        const tData = tSnap.data();
        const updatedOrganizers = tData.organizers.map(org => {
          if (org.id === user.uid) {
            return { ...org, status: 'active' };
          }
          return org;
        });
        batch.update(tRef, { organizers: updatedOrganizers });

        // --- ÚJ: ÉRTESÍTÉS A TÖBBI SZERVEZŐNEK A CSATLAKOZÁSRÓL ---
        const activeOrganizers = tData.organizers?.filter(org =>
          org.id !== user.uid && (org.status === 'active' || org.status === 'owner')
        ) || [];

        activeOrganizers.forEach(org => {
          const newNotifRef = doc(collection(db, "notifications"));
          batch.set(newNotifRef, {
            toUserId: org.id,
            fromUserId: user.uid,
            fromUserName: tData.organizers?.find(o => o.id === user.uid)?.name || "Egyik szervező",
            tournamentId: invite.tournamentId,
            tournamentName: invite.tournamentName,
            type: "tournament_invite_accepted",
            status: "unread",
            createdAt: serverTimestamp()
          });
        });
      }

      await batch.commit();
      alert(`Sikeresen csatlakoztál a(z) ${invite.tournamentName} kupasorozathoz! 🤝`);
      setActiveTab('championship'); // Át is viszünk a Kupasorozat lapra
    } catch (error) {
      console.error("Hiba a meghívó elfogadásakor:", error);
      alert("Nem sikerült elfogadni a meghívót!");
    }
  };

  const handleRejectInvite = async (invite) => {
    try {
      const batch = writeBatch(db);

      // 1. Értesítés törlése (elutasításkor is takarítunk)
      batch.delete(doc(db, "notifications", invite.id));

      // 2. Kupa dokumentumban az organizers tömb frissítése (kivesszük belőle)
      const tRef = doc(db, "tournaments", invite.tournamentId);
      const tSnap = await getDoc(tRef);
      if (tSnap.exists()) {
        const tData = tSnap.data();
        const updatedOrganizers = tData.organizers.filter(org => org.id !== user.uid);
        batch.update(tRef, { organizers: updatedOrganizers });
      }

      await batch.commit();
    } catch (error) {
      console.error("Hiba a meghívó elutasításakor:", error);
    }
  };

  // --- ÉVENKÉNTI CSOPORTOSÍTÁS LOGIKÁJA ---
  const getCompYear = (comp) => {
    if (comp.competitionDate) {
      const match = comp.competitionDate.match(/\d{4}/);
      if (match) return match[0];
    }
    if (comp.closedAt) return new Date(comp.closedAt).getFullYear().toString();
    if (comp.createdAt) {
      if (comp.createdAt.seconds) return new Date(comp.createdAt.seconds * 1000).getFullYear().toString();
      return new Date(comp.createdAt).getFullYear().toString();
    }
    return "Ismeretlen év";
  };

  const pastByYear = pastCompetitions.reduce((acc, comp) => {
    const year = getCompYear(comp);
    if (!acc[year]) acc[year] = [];
    acc[year].push(comp);
    return acc;
  }, {});

  const sortedYears = Object.keys(pastByYear).sort((a, b) => {
    if (a === "Ismeretlen év") return 1;
    if (b === "Ismeretlen év") return -1;
    return b.localeCompare(a);
  });

  const toggleYear = (year, index) => {
    setExpandedYears(prev => {
      const currentState = prev[year] !== undefined ? prev[year] : (index === 0);
      return { ...prev, [year]: !currentState };
    });
  };

  const renderCompCard = (comp) => {
    const hasCover = comp.coverImageUrl || comp.imageUrl;
    const currentCardStyle = hasCover ? {
      ...compCardStyle,
      backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.45), rgba(0, 0, 0, 0.65)), url(${hasCover})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      color: '#FFFFFF',
      textShadow: '0 2px 4px rgba(0, 0, 0, 0.8)'
    } : compCardStyle;
    const currentInfoStyle = hasCover ? { ...infoRowStyle, color: '#FFFFFF', textShadow: '0 1px 3px rgba(0, 0, 0, 0.9)' } : infoRowStyle;

    return (
      <div key={comp.id} style={currentCardStyle}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '15px' }}>
          <div style={{ display: 'flex', gap: '8px' }}>
            <span style={statusBadgeStyle(comp.status || 'Aktív')}>{comp.status || 'Aktív'}</span>
            {comp.status === 'Ready to Upload' && (
              <span style={{
                backgroundColor: '#e6fffa', color: '#2c7a7b', padding: '4px 10px',
                borderRadius: '20px', fontSize: '12px', fontWeight: 'bold', border: '1px solid #b2f5ea'
              }}>
                FELTÖLTÉSRE KÉSZ
              </span>
            )}
            {comp.creationType === 'announcement' && comp.status !== 'Ready to Upload' && (
              <span style={{
                backgroundColor: '#fff5f5', color: '#c53030', padding: '4px 10px',
                borderRadius: '20px', fontSize: '12px', fontWeight: '900', border: '1px solid #feb2b2'
              }}>
                NEVEZÉS ZÁRVA
              </span>
            )}
            {comp.isFeedShared && (
              <span
                onClick={() => openRevokeShareModal(comp)}
                style={{
                  backgroundColor: '#ebf8ff',
                  color: '#2b6cb0',
                  padding: '4px 10px',
                  borderRadius: '20px',
                  fontSize: '12px',
                  fontWeight: 'bold',
                  border: '1px solid #bee3f8',
                  cursor: 'pointer',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '4px'
                }}
                title="Kattints a megosztás visszavonásához"
              >
                <FiShare2 size={12} /> Megosztva Appban
              </span>
            )}
          </div>
          <div style={{ display: 'flex', gap: '10px' }}>
            {activeTab === 'active' && (
              <FiCopy
                style={{ cursor: 'pointer', color: hasCover ? '#fff' : '#1877F2' }}
                title="Másolás új versenynek"
                onClick={() => handleCopyCompetition(comp)}
              />
            )}
            {activeTab === 'active' && (
              <FiEdit2
                style={{ cursor: 'pointer', color: hasCover ? '#fff' : '#666' }}
                title="Szerkesztés"
                onClick={() => navigate(`/verseny-szerkesztes/${comp.id}`)}
              />
            )}
            {activeTab === 'active' && (
              comp.isHidden ? (
                <FiEyeOff
                  style={{ cursor: 'pointer', color: '#b30000' }}
                  title="Jelenleg rejtett a kiírások közül – Kattints a megjelenítéshez"
                  onClick={() => handleToggleHideCompetition(comp)}
                />
              ) : (
                <FiEye
                  style={{ cursor: 'pointer', color: '#28a745' }}
                  title="Jelenleg látható a kiírások között – Kattints az elrejtéshez"
                  onClick={() => handleToggleHideCompetition(comp)}
                />
              )
            )}
            <FiTrash2
              style={{ cursor: 'pointer', color: '#b30000' }}
              title={activeTab === 'active' ? "Törlés" : "Elrejtés az Irányítópultról"}
              onClick={() => openDeleteModal(comp)}
            />
          </div>
        </div>

        <h4 style={{ margin: '0 0 15px 0', fontSize: '18px', color: hasCover ? '#FFFFFF' : '#333' }}>
          {comp.competitionName || comp.title}
        </h4>

        <div style={currentInfoStyle}>
          <FiCalendar /> {comp.competitionDate || 'Nincs megadva dátum'}
        </div>
        <div style={currentInfoStyle}><FiMapPin /> {comp.location || 'Nincs megadva helyszín'}</div>
        <div style={currentInfoStyle}><FiUsers /> {comp.participantsCount || 0} nevező regisztrált</div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '15px' }}>
          {activeTab === 'active' && comp.creationType !== 'announcement' && (
            (() => {
              const localCount = offlineStats[comp.id];
              const remoteCount = comp.participantsCount || 0;
              const isLocalStored = localStorage.getItem(`offline_downloaded_${comp.id}`) === 'true';
              const isDownloaded = comp.isOfflineDownloaded === true || isLocalStored || (localCount !== undefined && localCount > 0);
              const needsUpdate = !isDownloaded && localCount !== undefined && localCount < remoteCount;

              let btnColor = '#ff9800';
              let btnText = 'Adatok letöltése offline módhoz';
              let borderColor = '#fb8c00';

              if (isDownloaded) {
                if (needsUpdate) {
                  const diff = Math.max(1, remoteCount - localCount);
                  btnColor = '#e53e3e';
                  btnText = `Frissítés szükséges (${diff} új!)`;
                  borderColor = '#c53030';
                } else {
                  btnColor = '#28a745';
                  btnText = 'Offline mód előkészítve';
                  borderColor = '#218838';
                }
              }

              return (
                <button
                  style={{
                    ...manageButtonStyle,
                    backgroundColor: btnColor,
                    color: '#fff',
                    borderColor: borderColor,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px'
                  }}
                  onClick={() => downloadCompetitionOffline(comp)}
                >
                  <FiDownload size={16} />
                  {btnText}
                </button>
              );
            })()
          )}

          <div style={{ display: 'flex', gap: '10px' }}>
            <button
              style={manageButtonStyle}
              onClick={() => navigate(`/versenyiroda/${comp.id}`)}
            >
              Versenyiroda
            </button>

            {comp.status === 'Ready to Upload' && (
              <button
                style={{
                  ...manageButtonStyle,
                  backgroundColor: '#28a745', // ZÖLD GOMB
                  color: '#fff',
                  borderColor: '#218838'
                }}
                onClick={() => {
                  setCompToPublish(comp);
                  setShowPublishConfirmModal(true);
                }}
              >
                Eredmények feltöltése
              </button>
            )}

            {activeTab === 'past' && comp.status === 'Lezárt' && (
              <button
                style={{
                  ...manageButtonStyle,
                  backgroundColor: '#eee',
                  color: '#888',
                  borderColor: '#ddd',
                  cursor: 'default'
                }}
                disabled
              >
                Eredmények feltöltve
              </button>
            )}

            {comp.creationType === 'announcement' && comp.status === 'Aktív' && (
              <button
                style={{
                  ...manageButtonStyle,
                  backgroundColor: '#b30000',
                  color: '#fff',
                  borderColor: '#b30000'
                }}
                onClick={() => {
                  setCompToOpen(comp);
                  setShowOpenRegistrationModal(true);
                }}
              >
                Nevezés megnyitása
              </button>
            )}
          </div>
        </div>

        {activeTab === 'active' && (
          <div
            onClick={() => {
              setCompToShare(comp);
              setShowShareModal(true);
              setCopySuccess(false);
            }}
            style={{
              position: 'absolute',
              bottom: '-12px',
              right: '15px',
              backgroundColor: '#1877F2',
              color: '#fff',
              padding: '5px 12px',
              borderRadius: '0 0 10px 10px',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              fontSize: '0.75rem',
              fontWeight: 'bold',
              cursor: 'pointer',
              boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
              zIndex: 5,
              transition: 'all 0.2s ease'
            }}
            onMouseOver={(e) => { e.currentTarget.style.bottom = '-15px'; e.currentTarget.style.paddingBottom = '8px'; }}
            onMouseOut={(e) => { e.currentTarget.style.bottom = '-12px'; e.currentTarget.style.paddingBottom = '5px'; }}
          >
            <FiShare2 size={14} />
            <span>MEGOSZTÁS</span>
          </div>
        )}

        {activeTab === 'past' && (
          <div style={{ position: 'absolute', bottom: '-12px', left: '15px', zIndex: 10, display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div
              onClick={() => handleToggleRatings(comp)}
              style={{
                backgroundColor: '#b30000',
                color: '#fff',
                padding: '5px 14px',
                borderRadius: '0 0 10px 10px',
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                fontSize: '0.75rem',
                fontWeight: 'bold',
                cursor: 'pointer',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                transition: 'all 0.2s ease'
              }}
            >
              <FiAward size={14} />
              <span>ÉRTÉKELÉSEK</span>
            </div>

            {expandedRatingCompId === comp.id && (
              <div style={{
                position: 'absolute',
                left: '110px',
                bottom: '-12px',
                backgroundColor: 'white',
                color: '#333',
                padding: '10px 14px',
                borderRadius: '10px',
                boxShadow: '0 6px 20px rgba(0,0,0,0.25)',
                border: '1px solid #ddd',
                fontSize: '0.8rem',
                minWidth: '290px',
                zIndex: 20
              }}>
                <div style={{ fontWeight: 'bold', color: '#b30000', marginBottom: '6px', borderBottom: '1px solid #eee', paddingBottom: '4px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span>Értékelések ({competitionAverages[comp.id]?.count || 0} szavazat)</span>
                  <FiX size={14} style={{ cursor: 'pointer' }} onClick={() => setExpandedRatingCompId(null)} />
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '6px 12px' }}>
                  <div>🅿️ Parkolás: <strong>{competitionAverages[comp.id]?.parking}</strong></div>
                  <div>🏢 Iroda: <strong>{competitionAverages[comp.id]?.office}</strong></div>
                  <div>📋 Szervezés: <strong>{competitionAverages[comp.id]?.organization}</strong></div>
                  <div>🎯 Pálya: <strong>{competitionAverages[comp.id]?.course}</strong></div>
                  <div style={{ gridColumn: 'span 2', textAlign: 'left', marginTop: '2px', paddingTop: '2px' }}>🍽️ Vendéglátás: <strong>{competitionAverages[comp.id]?.catering}</strong></div>
                </div>
              </div>
            )}
          </div>
        )}

        {comp.creationType === 'announcement' && (
          <div style={{
            position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%) rotate(-15deg)',
            fontSize: '2rem', fontWeight: '900', color: 'rgba(197, 48, 48, 0.1)', pointerEvents: 'none',
            whiteSpace: 'nowrap', textTransform: 'uppercase', zIndex: 0
          }}>
            Nevezés zárva
          </div>
        )}
      </div>
    );
  };

  // --- MOBIL SOROMPÓ NÉZET ---
  if (isMobile) {
    return (
      <div style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        height: 'calc(100vh - 64px)', padding: '20px', textAlign: 'center', backgroundColor: '#f4f6f8'
      }}>
        <div style={{
          backgroundColor: '#fff', padding: '40px 30px', borderRadius: '20px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.1)', maxWidth: '400px'
        }}>
          <div style={{
            width: '80px', height: '80px', backgroundColor: '#fff5f5', color: '#b30000',
            borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 20px auto'
          }}>
            <FiAlertTriangle size={40} />
          </div>
          <h2 style={{ color: '#333', marginBottom: '15px' }}>Egyesületi funkciók</h2>
          <p style={{ color: '#666', lineHeight: '1.6', marginBottom: '25px' }}>
            Sajnáljuk, de az <strong>Irányítópult</strong> és a <strong>Versenyiroda</strong> jelenleg csak számítógépről érhető el.
          </p>
          <div style={{
            padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '12px',
            fontSize: '0.9rem', color: '#555', border: '1px solid #eee'
          }}>
            Kérjük, a versenyek kezeléséhez és az irodai munkához jelentkezz be egy <strong>asztali böngészőből!</strong> 💻
          </div>
          <button
            onClick={() => navigate('/')}
            style={{
              marginTop: '30px', width: '100%', padding: '12px',
              backgroundColor: '#b30000', color: '#fff', border: 'none',
              borderRadius: '10px', fontWeight: 'bold', cursor: 'pointer'
            }}
          >
            Vissza a főoldalra
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#f4f6f8', fontFamily: 'Arial, sans-serif' }}>
      
      {/* --- OLDALSÓ MENÜ (SIDEBAR) --- */}
      <div style={{
        width: '300px',
        backgroundColor: '#fff',
        borderRight: '1px solid #eee',
        padding: '20px 15px',
        display: 'flex',
        flexDirection: 'column',
        gap: '15px',
        position: 'sticky',
        top: 0,
        height: '100vh',
        boxSizing: 'border-box',
        zIndex: 100
      }}>
        {/* SIDEBAR PROFIL FEJLÉC */}
        <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
          <div style={{ position: 'relative' }}>
            <div style={{
              width: '100px',
              height: '100px',
              borderRadius: '50%',
              backgroundColor: '#eee',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              overflow: 'hidden',
              border: '3px solid #fff',
              boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
            }}>
              {clubData?.logoUrl ? (
                <img src={clubData.logoUrl} alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              ) : (
                <FiUsers size={50} color="#ccc" />
              )}

              {isUploadingLogo && (
                <div style={{
                  position: 'absolute', top: 0, left: 0, right: 0, bottom: 0,
                  backgroundColor: 'rgba(255,255,255,0.7)', display: 'flex', alignItems: 'center', justifyContent: 'center'
                }}>
                  <div className="upload-spinner" />
                </div>
              )}
            </div>

            <button
              onClick={() => fileInputRef.current?.click()}
              style={{
                position: 'absolute',
                bottom: '0',
                right: '0',
                backgroundColor: '#b30000',
                color: '#fff',
                border: '2px solid #fff',
                borderRadius: '50%',
                width: '32px',
                height: '32px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                boxShadow: '0 2px 5px rgba(0,0,0,0.2)'
              }}
              title="Logó feltöltése"
            >
              <FiCamera size={18} />
            </button>

            <input
              type="file"
              ref={fileInputRef}
              onChange={handleLogoUpload}
              style={{ display: 'none' }}
              accept="image/*"
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
            <h3 style={{ color: '#333', margin: '0', fontSize: '1.2rem', fontWeight: '900' }}>
              {clubData?.clubName || clubData?.fullName || "Egyesület"}
            </h3>
            <button
              onClick={() => setActiveTab('club-profile')}
              style={{
                backgroundColor: '#b30000',
                color: 'white',
                border: 'none',
                padding: '6px 15px',
                borderRadius: '20px',
                fontSize: '0.8rem',
                fontWeight: 'bold',
                cursor: 'pointer',
                boxShadow: '0 2px 5px rgba(179,0,0,0.2)',
                transition: '0.2s',
                opacity: activeTab === 'club-profile' ? 0.7 : 1
              }}
            >
              Egyesületi Profil
            </button>
            <div
              onClick={() => setActiveTab('followers')}
              style={{
                marginTop: '4px',
                fontSize: '0.8rem',
                fontWeight: 'bold',
                color: '#666',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                gap: '4px',
                padding: '3px 10px',
                borderRadius: '12px',
                backgroundColor: activeTab === 'followers' ? '#fff5f5' : '#f8f9fa',
                border: '1px solid #eee',
                transition: '0.2s'
              }}
              title="Követők megtekintése"
            >
              <FiUsers size={13} color="#b30000" />
              <span>Követők: <strong style={{ color: '#b30000' }}>{followersList.length}</strong></span>
            </div>
          </div>
        </div>

        <div style={{ height: '1px', backgroundColor: '#f0f0f0', width: '100%' }} />

        {/* TELEPÍTÉS GOMB (Mindig látszik böngészőben) */}
        {!isStandalone && (
          <button
            onClick={() => setShowInstallInfoModal(true)}
            style={{
              width: '100%',
              backgroundColor: '#b30000',
              color: 'white',
              border: 'none',
              padding: '12px',
              borderRadius: '10px',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px',
              cursor: 'pointer',
              boxShadow: '0 4px 8px rgba(179,0,0,0.2)',
              marginBottom: '15px'
            }}
          >
            <FiDownload size={20} />
            ArcheryNexus letöltése
          </button>
        )}

        {/* --- MENÜPONTOK --- */}
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '5px' }}>

          {/* 1. VERSENYEIM */}
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <div
              onClick={() => setExpandedMenu(expandedMenu === 'competitions' ? null : 'competitions')}
              style={{ ...sidebarItemStyle, backgroundColor: expandedMenu === 'competitions' ? '#fff5f5' : 'transparent' }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <FiCalendar size={18} color="#b30000" />
                <span style={{ fontWeight: 'bold', color: '#333' }}>Versenyeim</span>
              </div>
              {expandedMenu === 'competitions' ? <FiChevronUp color="#888" /> : <FiChevronDown color="#888" />}
            </div>

            {expandedMenu === 'competitions' && (
              <div style={{ display: 'flex', flexDirection: 'column', paddingLeft: '42px', gap: '5px', marginTop: '5px' }}>
                <div
                  onClick={() => setActiveTab('active')}
                  style={{ ...sidebarSubItemStyle, color: activeTab === 'active' ? '#b30000' : '#666', fontWeight: activeTab === 'active' ? 'bold' : 'normal' }}
                >
                  Aktív versenyek
                </div>
                <div
                  onClick={() => setActiveTab('past')}
                  style={{ ...sidebarSubItemStyle, color: activeTab === 'past' ? '#b30000' : '#666', fontWeight: activeTab === 'past' ? 'bold' : 'normal' }}
                >
                  Lezárt versenyek
                </div>
              </div>
            )}
          </div>

          {/* ÚJ: 1.5. KUPASOROZAT (ZÁRT BÉTA) */}
          {isBetaTester && (
            <div
              onClick={() => setActiveTab('championship')}
              style={{
                ...sidebarItemStyle,
                backgroundColor: activeTab === 'championship' ? '#fff5f5' : 'transparent',
                position: 'relative' // A piros pötty miatt
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                <FiAward size={18} color="#b30000" />
                <span style={{ fontWeight: 'bold', color: activeTab === 'championship' ? '#b30000' : '#333' }}>
                  Kupasorozat <span style={{ fontSize: '0.65rem', backgroundColor: '#e6fffa', color: '#2c7a7b', padding: '2px 5px', borderRadius: '4px', marginLeft: '5px', fontWeight: '900', verticalAlign: 'middle' }}>BÉTA</span>
                </span>
              </div>

              {/* ÉRTESÍTÉS PÖTTY */}
              {pendingInvitations.length > 0 && (
                <div style={{
                  backgroundColor: '#dc3545',
                  color: 'white',
                  fontSize: '0.7rem',
                  fontWeight: 'bold',
                  width: '18px',
                  height: '18px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 2px 4px rgba(220,53,69,0.3)'
                }}>
                  {pendingInvitations.length}
                </div>
              )}
            </div>
          )}

          {/* 2. DOKUMENTUMOK */}
          <div style={{ ...sidebarItemStyle, opacity: 0.6, cursor: 'default' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <FiFileText size={18} color="#b30000" />
              <span style={{ fontWeight: 'bold', color: '#333' }}>Dokumentumok</span>
            </div>
          </div>

          {/* 3. BEÁLLÍTÁSOK */}
          <div style={{ ...sidebarItemStyle, opacity: 0.6, cursor: 'default' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <FiSettings size={18} color="#b30000" />
              <span style={{ fontWeight: 'bold', color: '#333' }}>Beállítások</span>
            </div>
          </div>

          {/* 4. HIBAJELENTÉS / VISSZAJELZÉS */}
          <div
            onClick={() => navigate('/visszajelzes')}
            style={sidebarItemStyle}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <FiMessageSquare size={18} color="#b30000" />
              <span style={{ fontWeight: 'bold', color: '#333', lineHeight: '1.2' }}>
                Hibajelentés /<br/>Visszajelzés
              </span>
            </div>
          </div>

        </div>
      </div>

      {/* --- FŐ TARTALOM (JOBB OLDAL) --- */}
      <div style={{ flex: 1, padding: '40px', overflowY: 'auto' }}>

        {/* --- EGYESÜLETI PROFIL SZERKESZTŐ NÉZET --- */}
        {activeTab === 'club-profile' && (
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '30px' }}>
              <button
                onClick={() => setActiveTab('active')}
                style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#666', display: 'flex', alignItems: 'center' }}
              >
                <FiArrowDown style={{ transform: 'rotate(90deg)' }} size={24} />
              </button>
              <h2 style={{ color: '#b30000', margin: 0 }}>Egyesületi Profil Szerkesztése</h2>
            </div>

            <div style={{ ...compCardStyle, padding: '30px' }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>

                {/* KLUB NEVE */}
                <div style={{ gridColumn: '1 / -1' }}>
                  <label style={labelStyle}>Egyesület Hivatalos Neve</label>
                  <input
                    type="text"
                    value={profileForm.clubName}
                    onChange={(e) => setProfileForm({...profileForm, clubName: e.target.value})}
                    style={inputStyle}
                    placeholder="Egyesület neve"
                  />
                </div>

                {/* KAPCSOLATTARTÓ */}
                <div>
                  <label style={labelStyle}>Kapcsolattartó Neve</label>
                  <input
                    type="text"
                    value={profileForm.contactPerson}
                    onChange={(e) => setProfileForm({...profileForm, contactPerson: e.target.value})}
                    style={inputStyle}
                    placeholder="Példa János"
                  />
                </div>

                {/* EMAIL */}
                <div>
                  <label style={labelStyle}>Email Cím</label>
                  <input
                    type="email"
                    value={profileForm.email}
                    onChange={(e) => setProfileForm({...profileForm, email: e.target.value})}
                    style={inputStyle}
                    placeholder="iroda@egyesulet.hu"
                  />
                </div>

                {/* TELEFONSZÁM */}
                <div>
                  <label style={labelStyle}>Telefonszám</label>
                  <input
                    type="text"
                    value={profileForm.phone}
                    onChange={(e) => setProfileForm({...profileForm, phone: e.target.value})}
                    style={inputStyle}
                    placeholder="+36 30 123 4567"
                  />
                </div>

                {/* SZÉKHELY - ORSZÁG */}
                <div>
                  <label style={labelStyle}>Ország</label>
                  <input
                    type="text"
                    value={profileForm.country}
                    onChange={(e) => setProfileForm({...profileForm, country: e.target.value})}
                    style={inputStyle}
                  />
                </div>

                {/* SZÉKHELY - VÁROS */}
                <div>
                  <label style={labelStyle}>Város (Helyszín)</label>
                  <input
                    type="text"
                    value={profileForm.location}
                    onChange={(e) => setProfileForm({...profileForm, location: e.target.value})}
                    style={inputStyle}
                  />
                </div>

                {/* PONTOS CÍM */}
                <div style={{ gridColumn: '1 / -1' }}>
                  <label style={labelStyle}>Pontos Cím (Utca, házszám)</label>
                  <input
                    type="text"
                    value={profileForm.address}
                    onChange={(e) => setProfileForm({...profileForm, address: e.target.value})}
                    style={inputStyle}
                    placeholder="Íjász utca 12."
                  />
                </div>

              </div>

              <div style={{ marginTop: '40px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <p style={{ color: '#666', fontSize: '0.85rem', margin: 0, fontStyle: 'italic' }}>
                  * Az itt megadott adatok nyilvánosak mindenki számára.
                </p>
                <button
                  onClick={handleSaveClubProfile}
                  disabled={isSavingProfile}
                  style={{
                    ...createButtonStyle,
                    padding: '12px 40px',
                    opacity: isSavingProfile ? 0.7 : 1,
                    marginBottom: 0 // Kínos margó eltávolítása
                  }}
                >
                  {isSavingProfile ? 'Mentés...' : 'Változtatások Mentése'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* --- ÚJ: KUPASOROZAT (CHAMPIONSHIP) NÉZET --- */}
        {activeTab === 'championship' && isBetaTester && (
          <Tournaments />
        )}

        {/* --- ÚJ: ÉRTESÍTÉSEK SÁVJA A DASHBOARD TETEJÉN --- */}
        {pendingInvitations.length > 0 && activeTab !== 'championship' && (
          <div style={{ marginBottom: '25px', display: 'flex', flexDirection: 'column', gap: '10px' }}>
            {pendingInvitations.map(inv => {
              let title = "Értesítés";
              let message = "";
              let icon = <FiAward />;
              let isActionable = inv.type === "tournament_invite";

              if (inv.type === "tournament_invite") {
                title = "Új Társrendezői Felkérés!";
                message = <>Meghívást kaptál a(z) <strong>{inv.tournamentName}</strong> kupasorozat szervezésébe.</>;
              } else if (inv.type === "tournament_invite_accepted") {
                title = "Új tag csatlakozott!";
                message = <><strong>{inv.fromUserName}</strong> elfogadta a meghívást a(z) <strong>{inv.tournamentName}</strong> kupasorozatba! 🤝</>;
                icon = <FiCheck />;
              } else if (inv.type === "competition_assigned") {
                title = "Verseny kijelölve!";
                message = <><strong>{inv.fromUserName}</strong> kijelölte a versenyt (<strong>{inv.eventName}</strong>) a(z) <strong>{inv.tournamentName}</strong> kupa {Number(inv.roundIndex) + 1}. fordulójához! 🏹</>;
                icon = <FiCalendar />;
              }

              return (
                <div key={inv.id} style={{
                  backgroundColor: '#fffaf0', border: '1px solid #fbd38d', borderRadius: '10px',
                  padding: '15px 20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                  boxShadow: '0 4px 6px rgba(0,0,0,0.05)'
                }}>
                  <div>
                    <h4 style={{ margin: '0 0 5px 0', color: '#b7791f', display: 'flex', alignItems: 'center', gap: '8px' }}>
                      {icon} {title}
                    </h4>
                    <p style={{ margin: 0, fontSize: '0.9rem', color: '#666' }}>
                      {message}
                    </p>
                  </div>
                  <div style={{ display: 'flex', gap: '10px' }}>
                    {isActionable ? (
                      <>
                        <button onClick={() => handleRejectInvite(inv)} style={{ backgroundColor: '#fff', border: '1px solid #ccc', padding: '8px 15px', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', color: '#666' }}>
                          Elutasít
                        </button>
                        <button onClick={() => handleAcceptInvite(inv)} style={{ backgroundColor: '#28a745', border: 'none', padding: '8px 15px', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', color: 'white', display: 'flex', alignItems: 'center', gap: '5px' }}>
                          <FiCheck /> Elfogad
                        </button>
                      </>
                    ) : (
                      <button
                        onClick={async () => {
                          try {
                            // --- ÚJ: Értesítés végleges törlése ---
                            await deleteDoc(doc(db, "notifications", inv.id));
                          } catch(e) { console.error("Hiba az értesítés törlésekor:", e); }
                        }}
                        style={{ backgroundColor: '#fff', border: '1px solid #ccc', padding: '8px 15px', borderRadius: '8px', cursor: 'pointer', fontWeight: 'bold', color: '#666' }}
                      >
                        Értem
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {/* KÖVETŐK NÉZET */}
        {activeTab === 'followers' && (
          <div style={{ backgroundColor: '#fff', borderRadius: '12px', padding: '30px', boxShadow: '0 4px 15px rgba(0,0,0,0.05)' }}>
            <h2 style={{ marginBottom: '20px', color: '#b30000', display: 'flex', alignItems: 'center', gap: '10px' }}>
              <FiUsers /> Egyesület követői ({followersList.length} fő)
            </h2>

            {followersList.length > 0 ? (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '15px' }}>
                {followersList.map(follower => (
                  <div key={follower.id} style={{
                    display: 'flex', alignItems: 'center', gap: '15px',
                    padding: '15px', backgroundColor: '#fafafa', borderRadius: '12px',
                    border: '1px solid #eee', boxShadow: '0 2px 5px rgba(0,0,0,0.03)'
                  }}>
                    <div style={{
                      width: '50px', height: '50px', borderRadius: '50%', backgroundColor: '#eee',
                      overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
                      border: '2px solid #fff', boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
                    }}>
                      {follower.profileImageUrl ? (
                        <img src={follower.profileImageUrl} alt="Profilkép" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                      ) : (
                        <FiUsers size={24} color="#999" />
                      )}
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                      <span style={{ fontWeight: 'bold', fontSize: '0.95rem', color: '#333', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {follower.fullName}
                      </span>
                      <span style={{ fontSize: '0.8rem', color: '#666', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', marginTop: '2px' }}>
                        {follower.club || 'Egyéni induló'}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div style={{ padding: '40px', textAlign: 'center', color: '#888', fontStyle: 'italic' }}>
                Még nincsenek követői ennek az egyesületnek.
              </div>
            )}
          </div>
        )}

        {/* VERSENYEK LISTÁJA FEJLÉC ÉS RÁCS */}
        {activeTab !== 'club-profile' && activeTab !== 'championship' && activeTab !== 'followers' && (
          <>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '25px', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
              <h2 style={{ color: '#b30000', margin: 0 }}>
                {activeTab === 'active' ? `Aktív versenyeid (${activeCompetitions.length})` : `Lezárt versenyek (${pastCompetitions.length})`}
              </h2>

              <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                <a
                  href="https://www.buymeacoffee.com/ArcheryNexus"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    padding: '8px 15px',
                    backgroundColor: '#FFDD00',
                    color: '#000000',
                    textDecoration: 'none',
                    borderRadius: '10px',
                    fontWeight: 'bold',
                    fontSize: '0.85rem',
                    boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
                  }}
                >
                  <span style={{ fontSize: '18px' }}>☕</span>
                  <span>Hívd meg a fejlesztőt egy kávéra</span>
                </a>

                <button
                  style={createButtonStyle}
                  onClick={() => navigate('/verseny-letrehozas')}
                >
                  <FiPlus size={20} />
                  <span>Új verseny létrehozása</span>
                </button>
              </div>
            </div>

            {activeTab === 'active' ? (
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '25px' }}>
                {activeCompetitions.length > 0 ? (
                  activeCompetitions.map(renderCompCard)
                ) : (
                  <div style={emptyStateStyle}>
                    <FiInbox size={50} style={{ marginBottom: '15px', color: '#ccc' }} />
                    <p style={{ margin: 0, fontWeight: 'bold', color: '#888' }}>
                      Még nincsenek aktív versenyeid.
                    </p>
                    <p style={{ fontSize: '14px', color: '#aaa' }}>Kattints az "Új verseny létrehozása" gombra!</p>
                  </div>
                )}
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                {sortedYears.length > 0 ? (
                  sortedYears.map((year, index) => {
                    const isExpanded = expandedYears[year] !== undefined ? expandedYears[year] : index === 0;
                    return (
                      <div key={year} style={{ backgroundColor: '#fff', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 8px rgba(0,0,0,0.05)' }}>
                        <div
                          style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', borderBottom: isExpanded ? '1px solid #eee' : 'none', paddingBottom: isExpanded ? '15px' : '0', marginBottom: isExpanded ? '20px' : '0' }}
                          onClick={() => toggleYear(year, index)}
                        >
                          <h3 style={{ margin: 0, color: '#b30000', fontSize: '1.2rem', display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <FiCalendar /> {year}
                            <span style={{ fontSize: '0.85rem', backgroundColor: '#f8f9fa', color: '#666', padding: '4px 10px', borderRadius: '20px', border: '1px solid #ddd' }}>
                              {pastByYear[year].length} verseny
                            </span>
                          </h3>
                          {isExpanded ? <FiChevronUp size={24} color="#888" /> : <FiChevronDown size={24} color="#888" />}
                        </div>
                        {isExpanded && (
                          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))', gap: '25px' }}>
                            {pastByYear[year].map(renderCompCard)}
                          </div>
                        )}
                      </div>
                    );
                  })
                ) : (
                  <div style={emptyStateStyle}>
                    <FiInbox size={50} style={{ marginBottom: '15px', color: '#ccc' }} />
                    <p style={{ margin: 0, fontWeight: 'bold', color: '#888' }}>
                      Még nincsenek lezárt versenyeid.
                    </p>
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </div>

      {/* --- MODALOK --- */}
      {showModal && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <FiAlertTriangle size={50} color="#b30000" style={{ marginBottom: '15px' }} />
            <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>
              {activeTab === 'active' ? 'Biztosan törölni szeretnéd?' : 'Biztosan elrejted?'}
            </h3>
            <p style={{ color: '#666', marginBottom: '25px', lineHeight: '1.5' }}>
              {activeTab === 'active' ? (
                <>Valóban törölni szeretnéd a(z) <br/> <strong>{compToDelete?.competitionName || compToDelete?.title}</strong> <br/> versenyt? Ez a művelet végleges.</>
              ) : (
                <>Elrejted a(z) <br/> <strong>{compToDelete?.competitionName || compToDelete?.title}</strong> <br/> versenyt a saját Irányítópultodról? Az eredmények a publikum számára továbbra is láthatók maradnak!</>
              )}
            </p>
            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
              <button style={modalCancelButtonStyle} onClick={() => setShowModal(false)}>Mégse</button>
              <button style={modalDeleteButtonStyle} onClick={handleFinalDelete}>
                {activeTab === 'active' ? 'Igen, törlöm' : 'Igen, elrejtem'}
              </button>
            </div>
          </div>
        </div>
      )}



      {showOpenRegistrationModal && (
        <div style={modalOverlayStyle} onClick={() => setShowOpenRegistrationModal(false)}>
          <div style={{ ...modalContentStyle, maxWidth: '450px' }} onClick={(e) => e.stopPropagation()}>
            <FiInfo size={50} color="#b30000" style={{ marginBottom: '15px' }} />
            <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>Nevezés megnyitása</h3>
            <p style={{ color: '#666', marginBottom: '25px', lineHeight: '1.5' }}>
              Biztosan meg akarod nyitni a nevezést?
            </p>
            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
              <button style={modalCancelButtonStyle} onClick={() => setShowOpenRegistrationModal(false)}>Mégse</button>
              <button style={{ ...modalDeleteButtonStyle, backgroundColor: '#28a745' }} onClick={handleOpenRegistration}>Igen, megnyitom</button>
            </div>
          </div>
        </div>
      )}

      {/* --- EREDMÉNYEK PUBLIKÁLÁSA CONFIRM MODAL --- */}
      {showPublishConfirmModal && (
        <div style={modalOverlayStyle} onClick={() => setShowPublishConfirmModal(false)}>
          <div style={{ ...modalContentStyle, maxWidth: '450px' }} onClick={(e) => e.stopPropagation()}>
            <FiInfo size={50} color="#28a745" style={{ marginBottom: '15px' }} />
            <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>Eredmények feltöltése</h3>
            <p style={{ color: '#666', marginBottom: '25px', lineHeight: '1.5' }}>
              Biztosan feltöltöd és publikálod a(z) <br/>
              <strong>{compToPublish?.competitionName}</strong> eredményeit? <br/><br/>
              Ezután a versenyzők azonnal látni fogják a rangsort az appban és a weben is.
            </p>
            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
              <button
                style={modalCancelButtonStyle}
                onClick={() => setShowPublishConfirmModal(false)}
                disabled={isPublishing}
              >
                Mégse
              </button>
              <button
                style={{ ...modalDeleteButtonStyle, backgroundColor: '#28a745' }}
                onClick={handleFinalPublish}
                disabled={isPublishing}
              >
                {isPublishing ? 'Feltöltés...' : 'Igen, publikálom'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* --- ARCHERYNEXUS ÉRTÉKELŐ MODAL --- */}
      {showRatingModal && (
        <div style={modalOverlayStyle} onClick={() => {}}>
          <div style={{ ...modalContentStyle, maxWidth: '550px', textAlign: 'left' }} onClick={(e) => e.stopPropagation()}>
            <h3 style={{ margin: '0 0 10px 0', color: '#b30000', fontSize: '1.4rem' }}>Értékeld az ArcheryNexust! 🏹⭐</h3>
            <p style={{ color: '#666', fontSize: '0.9rem', marginBottom: '10px' }}>
              Köszönjük a verseny sikeres lezárását és feltöltését! Kérjük, szánj 1 percet a verseny lebonyolításának értékelésére.
            </p>
            <div style={{ backgroundColor: '#fff5f5', border: '1px solid #feb2b2', padding: '8px 12px', borderRadius: '6px', marginBottom: '20px', fontSize: '0.85rem', color: '#c53030', fontWeight: 'bold' }}>
              💡 Kattints a csillagokra a pontszám beállításához (1-től 5-ig)!
            </div>

            {[
              { key: 'usability', label: 'Kezelhetőség' },
              { key: 'clarity', label: 'Átláthatóság' },
              { key: 'reliability', label: 'Megbízhatóság' },
              { key: 'participantsManagement', label: 'Nevezők kezelése / csapatbeosztás' },
              { key: 'resultsAggregation', label: 'Eredmények összesítése' }
            ].map(item => (
              <div key={item.key} style={{ marginBottom: '12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#f8f9fa', padding: '10px 15px', borderRadius: '8px', border: '1px solid #eee' }}>
                <span style={{ fontWeight: 'bold', fontSize: '0.9rem', color: '#333' }}>{item.label}</span>
                <div style={{ display: 'flex', gap: '4px' }}>
                  {[1, 2, 3, 4, 5].map(star => (
                    <button
                      key={star}
                      type="button"
                      onClick={() => setRatingForm({ ...ratingForm, [item.key]: star })}
                      style={{
                        background: 'none', border: 'none', fontSize: '1.4rem', cursor: 'pointer',
                        color: star <= ratingForm[item.key] ? '#ffc107' : '#cccccc',
                        padding: '0 2px'
                      }}
                      title={`${star} csillag`}
                    >
                      {star <= ratingForm[item.key] ? '★' : '☆'}
                    </button>
                  ))}
                </div>
              </div>
            ))}

            <div style={{ marginBottom: '15px', backgroundColor: '#f8f9fa', padding: '12px 15px', borderRadius: '8px', border: '1px solid #eee', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontWeight: 'bold', fontSize: '0.9rem', color: '#333' }}>Ajánlanád-e másoknak az ArcheryNexus-t?</span>
              <div style={{ display: 'flex', gap: '15px' }}>
                <label style={{ cursor: 'pointer', fontWeight: ratingForm.wouldRecommend ? 'bold' : 'normal', color: ratingForm.wouldRecommend ? '#28a745' : '#666' }}>
                  <input type="radio" name="wouldRecommend" checked={ratingForm.wouldRecommend} onChange={() => setRatingForm({ ...ratingForm, wouldRecommend: true })} style={{ marginRight: '5px' }} /> Igen
                </label>
                <label style={{ cursor: 'pointer', fontWeight: !ratingForm.wouldRecommend ? 'bold' : 'normal', color: !ratingForm.wouldRecommend ? '#b30000' : '#666' }}>
                  <input type="radio" name="wouldRecommend" checked={!ratingForm.wouldRecommend} onChange={() => setRatingForm({ ...ratingForm, wouldRecommend: false })} style={{ marginRight: '5px' }} /> Nem
                </label>
              </div>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', fontWeight: 'bold', fontSize: '0.9rem', color: '#333', marginBottom: '5px' }}>Egyéb megjegyzés:</label>
              <textarea
                style={{ width: '100%', minHeight: '80px', padding: '10px', borderRadius: '8px', border: '1px solid #ccc', boxSizing: 'border-box' }}
                value={ratingForm.comment}
                onChange={(e) => setRatingForm({ ...ratingForm, comment: e.target.value })}
                placeholder="Írd meg észrevételeidet, javaslataidat..."
              />
            </div>

            <div style={{ display: 'flex', gap: '15px', justifyContent: 'flex-end' }}>
              <button
                style={modalCancelButtonStyle}
                onClick={() => {
                  setShowRatingModal(false);
                  setCompBeingRated(null);
                  alert("Eredmények sikeresen feltöltve és publikálva! 🏹🚀");
                }}
              >
                Kihagyás
              </button>
              <button
                style={{ ...modalDeleteButtonStyle, backgroundColor: '#b30000', opacity: isSubmittingRating ? 0.7 : 1 }}
                onClick={handleSaveRating}
                disabled={isSubmittingRating}
              >
                {isSubmittingRating ? 'Mentés...' : 'Értékelés beküldése'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* --- TELEPÍTÉS INFÓ MODAL --- */}
      {showInstallInfoModal && (
        <div style={modalOverlayStyle} onClick={() => setShowInstallInfoModal(false)}>
          <div style={{ ...modalContentStyle, maxWidth: '550px' }} onClick={(e) => e.stopPropagation()}>
            <div style={{ backgroundColor: '#b30000', color: '#fff', padding: '20px', margin: '-30px -30px 20px -30px' }}>
               <h3 style={{ margin: 0 }}>Töltsd le az ArcheryNexus-t az offline élményért! 🏹</h3>
            </div>

            <p style={{ color: '#333', textAlign: 'left', lineHeight: '1.6', fontSize: '0.95rem', marginBottom: '20px' }}>
              Az ArcheryNexus letöltésével az alkalmazás közvetlenül a számítógépedre kerül.
              Így <strong>bárhol rendezz versenyt</strong>, a versenyiroda funkciók mindig működni fognak, akár internet nélkül is!
            </p>

            <p style={{ color: '#b30000', fontWeight: 'bold', textAlign: 'center', marginBottom: '15px' }}>
              A telepítéshez kattints a böngésződ címsorában (a webcím mellett) található telepítés ikonra:
            </p>

            {/* VIZUÁLIS ÚTMUTATÓ KÉPPEL ÉS NYÍLLAL */}
            <div style={{ position: 'relative', textAlign: 'center', marginBottom: '25px', backgroundColor: '#f9f9f9', padding: '15px', borderRadius: '12px', border: '1px solid #eee' }}>
              <div style={{
                position: 'absolute',
                top: '-10px',
                right: '150px',
                color: '#b30000',
                animation: 'bounceArrow 1s infinite'
              }}>
                <FiArrowDown size={40} strokeWidth={3} />
              </div>
              <img
                src={downloadHelpImg}
                alt="Telepítés segédlet"
                style={{ width: '100%', borderRadius: '8px', boxShadow: '0 4px 10px rgba(0,0,0,0.1)' }}
              />
            </div>

            <div style={{
              backgroundColor: '#fff5f5', border: '1px solid #feb2b2', padding: '15px',
              borderRadius: '8px', margin: '10px 0', textAlign: 'left'
            }}>
              <p style={{ color: '#c53030', margin: 0, fontWeight: 'bold' }}>
                💡 Ne felejtsd el!
              </p>
              <p style={{ color: '#666', fontSize: '0.85rem', marginTop: '5px' }}>
                A zavartalan offline munkához használd az aktuális verseny kártyáján található
                <strong> "Adatok letöltése offline módhoz"</strong> gombot!
              </p>
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '25px' }}>
              <button
                style={{ ...modalDeleteButtonStyle, backgroundColor: '#b30000', width: '150px' }}
                onClick={() => setShowInstallInfoModal(false)}
              >
                Értem!
              </button>
            </div>

            <style>{`
              @keyframes bounceArrow {
                0%, 100% { transform: translateY(0); }
                50% { transform: translateY(-10px); }
              }
            `}</style>
          </div>
        </div>
      )}

      {/* --- FELTURBÓZOTT MEGOSZTÁSI MODAL --- */}
      {showShareModal && compToShare && (
        <div style={modalOverlayStyle} onClick={() => setShowShareModal(false)}>
          <div style={{ ...modalContentStyle, maxWidth: '550px', padding: '25px', textAlign: 'left' }} onClick={(e) => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', borderBottom: '1px solid #eee', paddingBottom: '12px' }}>
              <h3 style={{ margin: 0, color: '#D32F2F', display: 'flex', alignItems: 'center', gap: '8px', fontSize: '1.2rem' }}>
                <FiShare2 /> Verseny megosztása
              </h3>
              <button type="button" onClick={() => setShowShareModal(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '1.3rem', color: '#666' }}>
                <FiX />
              </button>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>

              {/* 1. OPCIÓ: ARCHERYNEXUS KÖZÖSSÉGI POSZTOLÁS */}
              <div style={{ backgroundColor: '#fff5f5', padding: '16px', borderRadius: '12px', border: '1px solid #feb2b2' }}>
                <h4 style={{ margin: '0 0 8px 0', color: '#b30000', fontSize: '0.95rem' }}>
                  🔵 1. Verseny megosztása az ArcheryNexus-on
                </h4>
                <p style={{ fontSize: '0.8rem', color: '#666', marginBottom: '12px', lineHeight: '1.4' }}>
                  Posztold ki a versenyt az ArcheryNexus közösségi hírfolyamába! A bejegyzés megjelenik a hírfolyamban a verseny saját borítóképével és közvetlen Nevezési gombbal.
                </p>

                {/* KÉP ELŐNÉZET ÉS MÓDOSÍTÁS */}
                <div style={{ marginBottom: '12px' }}>
                  <label style={{ fontSize: '0.75rem', fontWeight: 'bold', color: '#b30000', display: 'block', marginBottom: '6px' }}>
                    VERSENY PLAKÁT / BORÍTÓKÉP:
                  </label>
                  <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                    {sharePosterPreview ? (
                      <img
                        src={sharePosterPreview}
                        alt="Plakát előnézet"
                        style={{ width: '80px', height: '60px', objectFit: 'cover', borderRadius: '8px', border: '1px solid #ddd' }}
                      />
                    ) : (
                      <div style={{ width: '80px', height: '60px', backgroundColor: '#eee', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#aaa', fontSize: '0.75rem' }}>
                        Nincs kép
                      </div>
                    )}
                    <button
                      type="button"
                      onClick={() => document.getElementById('sharePosterInput').click()}
                      style={{
                        padding: '8px 14px',
                        backgroundColor: '#fff',
                        color: '#b30000',
                        border: '1px solid #b30000',
                        borderRadius: '8px',
                        fontWeight: 'bold',
                        fontSize: '0.8rem',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px'
                      }}
                    >
                      <FiCamera /> {sharePosterPreview ? 'Plakát cseréje' : 'Plakát feltöltése'}
                    </button>
                    <input
                      id="sharePosterInput"
                      type="file"
                      accept="image/*"
                      onChange={handleSelectPosterFile}
                      style={{ display: 'none' }}
                    />
                  </div>
                </div>

                {/* EGYEDI ÜZENET */}
                <div style={{ marginBottom: '12px' }}>
                  <label style={{ fontSize: '0.75rem', fontWeight: 'bold', color: '#666', display: 'block', marginBottom: '4px' }}>
                    ÜZENET A POSZTHOZ:
                  </label>
                  <textarea
                    rows={3}
                    value={shareCustomCaption}
                    onChange={(e) => setShareCustomCaption(e.target.value)}
                    style={{
                      width: '100%', padding: '8px 10px', borderRadius: '8px', border: '1px solid #ddd',
                      fontSize: '0.85rem', resize: 'vertical', boxSizing: 'border-box'
                    }}
                  />
                </div>

                <button
                  type="button"
                  onClick={handlePublishToCommunityFeed}
                  disabled={isPublishingFeedPost || isUploadingPoster}
                  style={{
                    width: '100%',
                    padding: '10px',
                    backgroundColor: '#D32F2F',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '8px',
                    fontWeight: 'bold',
                    fontSize: '0.9rem',
                    cursor: (isPublishingFeedPost || isUploadingPoster) ? 'not-allowed' : 'pointer',
                    opacity: (isPublishingFeedPost || isUploadingPoster) ? 0.7 : 1
                  }}
                >
                  {isPublishingFeedPost ? 'Posztolás...' : '📣 Megosztás a Hírfolyamba'}
                </button>
              </div>

              {/* 2. OPCIÓ: KÜLSŐ LINK MÁSOLÁSA */}
              <div style={{ backgroundColor: '#f8f9fa', padding: '16px', borderRadius: '12px', border: '1px solid #eee' }}>
                <h4 style={{ margin: '0 0 8px 0', color: '#333', fontSize: '0.95rem' }}>
                  🔗 2. Link megosztása közösségi médiában
                </h4>
                <p style={{ fontSize: '0.8rem', color: '#666', marginBottom: '12px', lineHeight: '1.4' }}>
                  Másold ki a hivatkozást, amit beilleszthetsz Facebookra, Messengerre, Viberre vagy e-mailbe!
                </p>
                <button
                  type="button"
                  onClick={handleCopyLink}
                  style={{
                    width: '100%',
                    padding: '10px',
                    backgroundColor: copySuccess ? '#28a745' : '#1877F2',
                    color: '#fff',
                    border: 'none',
                    borderRadius: '8px',
                    fontWeight: 'bold',
                    fontSize: '0.9rem',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    transition: 'all 0.2s ease'
                  }}
                >
                  <FiCopy /> {copySuccess ? '✓ Link kimásolva!' : '📋 Hivatkozás másolása'}
                </button>
              </div>

            </div>
          </div>
        </div>
      )}

      {/* --- MEGOSZTÁS VISSZAVONÁSA MODAL --- */}
      {showRevokeShareModal && compToRevokeShare && (
        <div style={modalOverlayStyle} onClick={() => setShowRevokeShareModal(false)}>
          <div style={{ ...modalContentStyle, maxWidth: '450px', padding: '25px', textAlign: 'center' }} onClick={(e) => e.stopPropagation()}>
            <FiAlertTriangle size={50} color="#b30000" style={{ marginBottom: '15px' }} />
            <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>Megosztás visszavonása</h3>
            <p style={{ color: '#666', marginBottom: '25px', lineHeight: '1.5', fontSize: '0.95rem' }}>
              Biztosan vissza szeretnéd vonni a(z) <br />
              <strong>{compToRevokeShare.competitionName || compToRevokeShare.title}</strong> <br />
              megosztását az App Hírfolyamból? A bejegyzés törlődik a közösségi Hírfolyamból.
            </p>
            <div style={{ display: 'flex', gap: '15px', justifyContent: 'center' }}>
              <button style={modalCancelButtonStyle} onClick={() => setShowRevokeShareModal(false)}>Mégse</button>
              <button
                style={{ ...modalDeleteButtonStyle, backgroundColor: '#b30000' }}
                onClick={handleRevokeShareSubmit}
                disabled={isRevokingShare}
              >
                {isRevokingShare ? 'Törlés...' : 'Igen, visszavonom'}
              </button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        .upload-spinner {
          width: 24px; height: 24px;
          border: 3px solid #f3f3f3; border-top: 3px solid #b30000;
          border-radius: 50%; animation: spin 1s linear infinite;
        }
        @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
};

// --- STÍLUSOK (Visszaállítva multiline formátumba) ---

const tabContainerStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-end',
  marginBottom: '25px',
  borderBottom: '1px solid #eee'
};

const tabsWrapperStyle = {
  display: 'flex',
  gap: '30px'
};

const tabStyle = (isActive) => ({
  padding: '10px 5px',
  fontSize: '18px',
  fontWeight: 'bold',
  cursor: 'pointer',
  color: isActive ? '#b30000' : '#888',
  borderBottom: isActive ? '3px solid #b30000' : '3px solid transparent',
  transition: '0.3s ease'
});

const modalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.7)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 1000,
  backdropFilter: 'blur(3px)'
};

const modalContentStyle = {
  backgroundColor: 'white',
  padding: '30px',
  borderRadius: '15px',
  textAlign: 'center',
  maxWidth: '400px',
  width: '90%',
  boxShadow: '0 15px 35px rgba(0,0,0,0.3)'
};

const modalDeleteButtonStyle = {
  backgroundColor: '#b30000',
  color: 'white',
  border: 'none',
  padding: '12px 24px',
  borderRadius: '8px',
  fontWeight: 'bold',
  cursor: 'pointer'
};

const modalCancelButtonStyle = {
  backgroundColor: '#eee',
  color: '#333',
  border: 'none',
  padding: '12px 24px',
  borderRadius: '8px',
  fontWeight: 'bold',
  cursor: 'pointer'
};

const createButtonStyle = {
  backgroundColor: '#b30000',
  color: 'white',
  border: 'none',
  padding: '8px 15px',
  borderRadius: '10px',
  fontWeight: 'bold',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  fontSize: '15px',
  transition: '0.2s',
  marginBottom: '5px'
};

const statCardStyle = {
  backgroundColor: 'white',
  padding: '20px',
  borderRadius: '12px',
  boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
  borderLeft: '4px solid #b30000'
};

const compCardStyle = {
  backgroundColor: 'white',
  padding: '20px',
  borderRadius: '12px',
  boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
  position: 'relative',
  marginBottom: '25px'
};

const emptyStateStyle = {
  gridColumn: '1 / -1',
  textAlign: 'center',
  padding: '60px 20px',
  backgroundColor: '#fdfdfd',
  borderRadius: '12px',
  border: '2px dashed #eee',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center'
};

const statusBadgeStyle = (status) => ({
  backgroundColor: status === 'Aktív' ? '#e6fffa' : '#fffaf0',
  color: status === 'Aktív' ? '#2c7a7b' : '#b7791f',
  padding: '4px 10px',
  borderRadius: '20px',
  fontSize: '12px',
  fontWeight: 'bold'
});

const infoRowStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  fontSize: '14px',
  color: '#555',
  marginBottom: '8px'
};

const manageButtonStyle = {
  width: '100%',
  marginTop: '15px',
  padding: '10px',
  backgroundColor: '#FFFFFF',
  border: '1.5px solid #b30000',
  color: '#b30000',
  borderRadius: '6px',
  fontWeight: 'bold',
  cursor: 'pointer'
};

const featureItemStyle = {
  fontSize: '0.85rem',
  color: '#444',
  lineHeight: '1.4',
  marginTop: '5px'
};

const sidebarItemStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '12px 15px',
  borderRadius: '10px',
  cursor: 'pointer',
  transition: '0.2s',
  userSelect: 'none'
};

const sidebarSubItemStyle = {
  padding: '8px 0',
  fontSize: '0.9rem',
  color: '#666',
  cursor: 'pointer',
  transition: '0.2s'
};

const labelStyle = {
  display: 'block',
  fontSize: '0.8rem',
  fontWeight: 'bold',
  color: '#b30000',
  marginBottom: '8px',
  textTransform: 'uppercase'
};

const inputStyle = {
  width: '100%',
  padding: '12px 15px',
  borderRadius: '10px',
  border: '1px solid #ddd',
  fontSize: '1rem',
  boxSizing: 'border-box',
  outline: 'none',
  transition: 'border-color 0.2s'
};

export default ClubDashboard;


